import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import FindsCarousel from "../components/finds-carousel"

const findsItems = [
  {
    name: "IKEA DUKTIG Doll's Bed",
    link:
      "https://www.ikea.com/in/en/p/duktig-dolls-bed-with-bedlinen-set-pine-multicolour-10589221/",
    image:
      "https://www.ikea.com/in/en/images/products/duktig-dolls-bed-with-bedlinen-set-pine-multicolour__1293807_pe935271_s5.jpg?f=s",
    note: "10/10 highly recommended for cats and bunnies.",
    imgUrl: "https://imgur.com/a/Uu4ke8F",
  },
]

const FindsPage = () => (
  <Layout activePage="finds" showFooterNewsletter={false}>
    <SEO title="Good Finds" />
    <div className="container">
      <div className="page-header fade-hero">
        <div className="page-eyebrow">03 — GOOD FINDS</div>
        <div className="page-title">Good Finds</div>
        <div className="page-desc">
          Tools, reads, rabbit holes, and things worth your attention. Not big
          on gatekeeping.
        </div>
      </div>

      <FindsCarousel items={findsItems} />
    </div>
  </Layout>
)

export default FindsPage

export const pageQuery = graphql`
  query FindsPageData {
    site {
      siteMetadata {
        title
      }
    }
  }
`
